import { render, staticRenderFns } from "./ListPPDetail.vue?vue&type=template&id=55c0b7ff"
import script from "./ListPPDetail.vue?vue&type=script&lang=js"
export * from "./ListPPDetail.vue?vue&type=script&lang=js"
import style0 from "./ListPPDetail.vue?vue&type=style&index=0&id=55c0b7ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports